// OrderHistory.js
import React from "react";
export default function OrderHistory({ orders }) {
  if (!orders.length) {
    return (
      <div className="panel p-8 text-center">
        <h2 className="text-3xl mb-3">Order History</h2>
        <p className="text-[var(--muted)]">No orders yet.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-3xl mb-6">Order History</h2>
      <ul className="space-y-3">
        {orders.map((order, idx) => (
          <li key={idx} className="panel px-4 py-3 flex items-center justify-between">
            <span className="font-medium">{order.reference_number || "Order"}</span>
            <span className="text-sm text-[var(--muted)]">{order.status || "Processing"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
